export default __webpack_public_path__ + "static/media/close-icon.3be74bc5.svg";